import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-aws-deepblue flex flex-col items-center justify-center p-4">
      <div className="bg-aws-blue rounded-qnav shadow-aws-card p-8 max-w-md w-full text-center">
        <div className="h-16 w-16 rounded-full bg-aws-orange mx-auto flex items-center justify-center mb-6">
          <span className="text-aws-blue text-3xl font-bold">404</span>
        </div>

        <h1 className="text-2xl font-display font-bold text-white mb-4">Page Not Found</h1>

        <p className="text-secondary-300 mb-6">The page you are looking for doesn't exist or has been moved.</p>

        <Link to="/dashboard" className="qnav-btn-primary bg-aws-anchor hover:bg-primary-700 inline-block">
          Return to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
